import { Heading, Stack, VStack } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { ItemCard } from 'apps/TenantApp/components/ItemCard';
import React from 'react';

const Links = ({ linkIds }: { linkIds: string[] }) =>
  linkIds.length ? (
    <Stack>
      <Heading fontSize="md">{t`Links`}</Heading>
      <VStack alignItems="stretch">
        {linkIds.map((linkId) => (
          <ItemCard key={linkId} itemId={linkId} />
        ))}
      </VStack>
    </Stack>
  ) : null;

export default Links;
